// Module
var code = `<div appHeaderBar>
    <header-bar-title>Sign Up</header-bar-title>
</div>
<app-page-content [showWebFooter]="false" [usePagePadding]="true">
    <div class="HOA-layout-align HOA-layout-align--middle u-height-100p">
        <div class="HOA-container HOA-container-splash-box">
            <div class="HOA-splash__title HOA-splash__title--sm">Use your Property Coupon to Register
                <span class="u-textNoWrap">your Property</span>
            </div>
            <div class="HOA-splash-copy">You can capture your property details using your Property Coupon with
                the camera on your phone, or enter
                <span class="u-textNoWrap">them manually.</span>
            </div>
            <div class="HOA-splash-buttons-container">
                <button class="HOA-splash-buttons-container__button
                                HOA-splash-buttons-container__button--wider
                                Button
                                Button--outline"
                   (click)="manual()"
                   tid="manualButton">
                    Enter Manually
                </button>
                <div class="HOA-splash-buttons-container__spacer"></div>
                <button class="HOA-splash-buttons-container__button
                                HOA-splash-buttons-container__button--wider
                                Button
                                Button--blue"
                   (click)="camera()" tid="cameraButton">Use Camera</button>
            </div>
            <div class="u-pV9">
                <a (click)="cancel()">Cancel</a>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;